import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import Drawer from '../Drawer';
import Button from '../Button';

const Confirm = ({ classes, open, title, cancelLabel, label, text, onConfirm, onClose }) => (
  <Drawer title={title} open={!!open} onClose={onClose} classes={{ header: classes.header }}>
    <div className={classes.container}>
      <Typography className={classes.text}>{text}</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Button
            label={cancelLabel || 'Cancel'}
            onClick={onClose}
            variant="outlined"
            aria-label="cancel"
            data-testid="btn-cancel"
          />
        </Grid>
        <Grid item xs={6}>
          <Button label={label} onClick={onConfirm} aria-label="confirm" data-testid="btn-confirm" />
        </Grid>
      </Grid>
    </div>
  </Drawer>
);

Confirm.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  /** If true, the drawer is open. */
  open: PropTypes.bool,
  /** The title of the Drawer. */
  title: PropTypes.string,
  /** Optional label of cancel button. */
  cancelLabel: PropTypes.string,
  /** The text (or jsx) of the Drawer. */
  text: PropTypes.node,
  /** The label of the confirm Button. */
  label: PropTypes.string,
  /** Callback for confirm action. */
  onConfirm: PropTypes.func,
  /** Close handler. */
  onClose: PropTypes.func,
};

Confirm.defaultProps = {
  classes: {},
  open: false,
  title: '',
  text: '',
  label: '',
};

export default Confirm;
